import React from 'react';

import { themeStyle } from '@repo/ui/theming';

import { CardImage, CardLabel, CardWrapper } from './styles';
import { CardProps } from './types';

const Card: React.FC<CardProps> = (props) => {
  return (
    <CardWrapper isActive={props.isActive} onClick={props.onClick}>
      <CardImage alt="Background preset example" src={props.imageSrc} />
      <CardLabel color={themeStyle.varInkMedium}>{props.label}</CardLabel>
    </CardWrapper>
  );
};

export default Card;
